<template>
  <div class="settlement-panel">
    <div class="panel-header">
      <div class="panel-row" style="margin-bottom: 10px;">
        <span class="title">历史总收入:</span>
        <span class="data price">{{totalAmount / 100}}元</span>
      </div>

      <div class="panel-row">
        <span class="title">提现账号:</span>
        <ul class="date-list current-account">
          <li
            v-for="item in settleAccounts"
            :key="item.bankAccountId"
            :value="item.bankAccountId"
            :class="['date-item', account.bankAccountId === item.bankAccountId ? 'active' : '']"
            @click="onChangeAccount(item)"
          >
            {{item.bankAccountId}}
          </li>
        </ul>
      </div>

      <div class="panel-row">
        <span class="title">提现微信:</span>
        <ul class="date-list current-account">
          <li
            v-for="userInfo in account.userInfos"
            :key="userInfo.openId"
            :class="['date-item', (account.userInfo && account.userInfo.openId) === userInfo.openId ? 'active' : '']"
            @click="onChangeAccountUserInfo(userInfo)"
          >
            <i class="avatar" :style="{ backgroundImage: `url('${userInfo.avatar}')` }" />
            {{userInfo.nickname}}
          </li>
        </ul>
      </div>

      <div class="panel-row">
        <div class="balance">{{balanceLabel}}：<span className="num">{{((account || {}).balance / 100) || 0}}</span>元</div>
      </div>

      <div class="panel-row" style="margin: 10px 0;">
        <span class="title">结算单:</span>
        <a class="report-link" @click="onShowReportModal">查看结算单</a>
      </div>

      <div class="panel-row" v-if="(account || {}).balance > 0">
        <button class="operate-btn" type="primary" @click="onShowWithdrawModal">提现</button>
      </div>
    </div>

    <Table :data="tableStatistics" />

    <BaseModal :visiable="reportVisiable">
      <div class="report-modal">
        <div class="header">
          <span>结算单</span> <span class="icon-close" @click="onHideReportModal">x</span>
        </div>
        <Table :data="tableReports" />
      </div>
    </BaseModal>

    <BaseModal :visiable="visiable">
      <div class="tip-modal">
        <div class="tip-row">
          <label style="margin-bottom: 0;">提现金额（元）</label>
          <input v-model="amount" />
        </div>
        <div class="tip-text">微信官方个人提现规则： 单笔最小提现1元，单笔最大提现5000元，单日最大提现5000元</div>

        <div class="tip-footer">
          <button class="modal-btn" style="margin-right: 30px;" @click="onHideWithdrawModal">取消</button>
          <button class="modal-btn"  @click="onConfirmWithdraw">确定</button>
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import moment from 'moment'
import Table from '@/components/dushu/Table.vue'
import BaseModal from '@/components/BaseModal.vue'
import Settlement from '@/engine/Settlement'
import { utils } from '@/util/index'

const TYPES = {
  withdraw: '提现',
  rollback: '系统自动回滚',
  settlement: '结算',
  manual: '手动',
  default: '人工',
};

const fetchTransactions = (bankAccountId, vm) => {
  Settlement.fetchTransactions({
    bankAccountId: bankAccountId,
    'pagination.pageIndex': 1,
    'pagination.pageSize': 100
  }).then(({ data }) => {
    vm.tableStatistics.body = data.map(item => {
      const { createdAt, amount, type, withdrawOrders, balance } = item;
      const result = (withdrawOrders && withdrawOrders[0] && withdrawOrders[0].failedAt)? '失败' : '成功';
      return [
        moment(createdAt).format('YYYY-MM-DD HH:mm:ss'),
        amount / 100,
        TYPES[type] || TYPES.default,
        result,
        balance / 100,
      ];
    });
  });
}

export default {
  name: 'Settlement',
  components: {
    Table,
    BaseModal,
  },
  props: {
    totalAmount: {
      type: Number,
      default: () => {
        return 0
      },
    },
    settleAccount: {
      type: Object,
      default: () => {
        return {}
      },
    },
    settleAccounts: {
      type: Array,
      default: () => {
        return []
      },
    },
    reportUrls: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  mounted () {
    const date = this.reportUrls.length ? moment(this.reportUrls[0].date).format('MM月DD日') : '上一期';
    this.balanceLabel = `截止${date}结算可提现余额`;
    this.tableReports.body = this.reportUrls.map(item => {
      const url = item.reportUrl.replace('http://report.oss-cn-shanghai.aliyuncs.com', 'https://report.dushuhui.mobi');
      return [
        moment(item.date).format('YYYY-MM-DD'),
        utils.isAndroid() ? {html: '<a class="red" target="_blank" href='+ url +'>下载</a>'}
        : {html: '<a class="red" target="_blank" href='+ url +'>查看</a>'}
      ]
    });
  },
  data() {
    return {
      amount: null,
      account: {},
      balanceLabel: '',
      visiable: false,
      tableStatistics: {
        head: ['时间', '金额', '类型', '状态', '余额'],
        body: [],
      },
      reportVisiable: false,
      tableReports: {
        head: ['时间', '查看'],
        body: [],
      }
    }
  },
  watch: {
    settleAccount: {
      immediate:true,
      deep: true,
      handler() {
        this.account = {
          ...this.settleAccount,
          userInfo: this.settleAccount.userInfos[0],
        };
        fetchTransactions(this.account.bankAccountId, this);
      },
    }
  },
  methods: {
    onChangeAccount: function (account) {
      this.account = {
        ...account,
        userInfo: account.userInfos[0],
      };
      fetchTransactions(account.bankAccountId, this);
    },
    onChangeAccountUserInfo: function (userInfo) {
      this.account = {
        ...this.account,
        userInfo: userInfo,
      };
    },
    onShowWithdrawModal: function () {
      this.visiable = true;
    },
    onHideWithdrawModal: function () {
      this.visiable = false;
      this.amount = null;
    },
    onConfirmWithdraw: async function () {
      if (isNaN(this.amount)) {
        this.$toast('提现金额错误！');
        return;
      }

      if (+this.amount < 1 || +this.amount > 5000) {
        this.$toast('提现金额错误！');
        return;
      }
      const params = {
        amount: +(this.amount * 100).toFixed(),
        bankAccountId: parseInt(this.account.bankAccountId, 10) || 0,
        users: {
          [this.account.userInfo.appId]: this.account.userInfo.openId,
        },
      };
      const vm = this;
      Settlement.withdraw(params).then(() => {
        this.$toast('提现成功，微信转账中...');
        this.visiable = false;
        fetchTransactions(vm.account.bankAccountId, vm);
      }).catch(err => {
        const { error } = ((err || {}).response || {}).data || {};
        if (error) {
          this.$toast(error);
        }
      });
    },
    onShowReportModal: function () {
      this.reportVisiable = true;
    },
    onHideReportModal: function () {
      this.reportVisiable = false;
    },
  },
};
</script>

<style scoped lang="scss">
.settlement-panel {
  .panel-header {
    padding: .9375rem;
  }

  .current-account {
    display: inline-flex;
  }

  .operate-btn {
    font-size: 14px;
    line-height: 28px;
    color: #e51c23;
    border: 1px solid #e51c23;
    border-radius: 5px;
    padding: 0 20px;
    background-color: #fff;
    margin-top: 10px;
  }

  .report-link {
    color: #007bff;
    text-decoration: none;
    margin-left: 10px;
  }

  .report-modal,
  .tip-modal {
    width: 80vw;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    padding: 30px 0;
    position: relative;
    box-sizing: border-box;
    color: #101010;

    .tip-row {
      display: flex;
      align-items: center;
    }

    .tip-text {
      margin: 5px 20px;
      font-size: 12px;
      color: #f39c12;
    }

    .modal-btn {
      font-size: 14px;
      line-height: 28px;
      color: #e51c23;
      border: 1px solid #e51c23;
      border-radius: 5px;
      padding: 0 20px;
      background-color: #fff;
      margin-top: 10px;
    }

    .close {
      margin-top: 30px;
      width: 100%;
      font-size: 18px;
      line-height: 50px;
      color: rgb(27, 183, 11);
      border-top: 1px solid #ddd;
      text-align: center;
    }
  }

  .report-modal {
    width: inherit;
    max-height: 400px;
    overflow: auto;

    .header {
      display: flex;
      justify-content: space-around;
      width: 80vw;
    }

    .icon-close {
      font-size: 32px;
      line-height: 1;
      position: absolute;
      right: 20px;
      top: 0px;
    }
  }

  .date-item {
    display: inline-flex;
    align-items: center;

    .avatar {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      margin-right: 5px;
      background-size: cover;
    }
  }
}
</style>
